"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderShipmentToJSON = exports.OrderShipmentFromJSONTyped = exports.OrderShipmentFromJSON = exports.instanceOfOrderShipment = void 0;
var runtime_1 = require("../runtime");
var OrderItem_1 = require("./OrderItem");
/**
 * Check if a given object implements the OrderShipment interface.
 */
function instanceOfOrderShipment(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfOrderShipment = instanceOfOrderShipment;
function OrderShipmentFromJSON(json) {
    return OrderShipmentFromJSONTyped(json, false);
}
exports.OrderShipmentFromJSON = OrderShipmentFromJSON;
function OrderShipmentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
        'purchaseReferenceId': !(0, runtime_1.exists)(json, 'purchase_reference_id') ? undefined : json['purchase_reference_id'],
        'trackingUrl': !(0, runtime_1.exists)(json, 'tracking_url') ? undefined : json['tracking_url'],
        'userCancelable': !(0, runtime_1.exists)(json, 'user_cancelable') ? undefined : json['user_cancelable'],
        'deliveryEstimate': !(0, runtime_1.exists)(json, 'delivery_estimate') ? undefined : json['delivery_estimate'],
        'items': !(0, runtime_1.exists)(json, 'items') ? undefined : (json['items'] === null ? null : json['items'].map(OrderItem_1.OrderItemFromJSON)),
    };
}
exports.OrderShipmentFromJSONTyped = OrderShipmentFromJSONTyped;
function OrderShipmentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': value.status,
        'purchase_reference_id': value.purchaseReferenceId,
        'tracking_url': value.trackingUrl,
        'user_cancelable': value.userCancelable,
        'delivery_estimate': value.deliveryEstimate,
        'items': value.items === undefined ? undefined : (value.items === null ? null : value.items.map(OrderItem_1.OrderItemToJSON)),
    };
}
exports.OrderShipmentToJSON = OrderShipmentToJSON;
